import React from "react";

function WebProject({ middle, title, image, description, tech, website }) {
  return (
    <div
      className={`${
        middle ? "lg:pt-10 px-3 lg:scale-105" : "pt-0 px-6"
      } group cursor-pointer font-secondary`}
    >
      <img
        src={image}
        alt=""
        className={`h-32 ${
          middle ? "lg:h-44" : "lg:h-32"
        } object-contain mx-auto`}
      />
      <h3 className="font-semibold text-center my-2">{title}</h3>
      <p className="text-justify text-sm">{description}</p>
      <div className="flex items-center justify-center gap-x-1 gap-y-1 flex-wrap py-4">
        {tech.map((item) => (
          <p className="px-4 py-1 rounded-full bg-black text-xs text-white">
            {item}
          </p>
        ))}
      </div>
      <div>
        {/* <button className="btn btn-block btn-default shadow-sm">
          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg"
            className="h-6 w-6"
          />
          <p className="flex-1">View Github</p>
        </button> */}
        <button
          className="bg-gradient-to-tr from-secondary-dark to-secondary-light w-full flex items-center px-6 py-2 rounded-sm shadow-sm shadow-secondary-light text-white"
          onClick={() => window.open(website)}
        >
          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/chrome/chrome-original.svg"
            className="h-6 w-6"
          />
          <p className="flex-1">View Website</p>
        </button>
      </div>
    </div>
  );
}

export default WebProject;
